<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        Department Helplist
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-card-title>
            <div class="headline">Departments List</div>
            <v-spacer></v-spacer>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="pagination"
              item-key="name"
              :loading="loading"
              :no-data-text="noDataText"
              :custom-filter="customSearch"
            >
              <template v-slot:item="row"
                ><tr>
                  <td class="text-xs-left">{{ row.item.dept }}</td>
                  <td class="text-xs-left">{{ row.item.deptDesc }}</td>
                  <td class="text-xs-center">
                    <v-btn text icon color="primary" type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr></template
              >
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      headers: [
        { text: 'Department', value: 'dept' },
        { text: 'Description', value: 'deptDesc' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.getDeptList
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.get(apiURI)
          this.items = []
          const { data } = result.data
          if (data) {
            data.map((dept) => {
              const convertList = {
                dept: dept.dept,
                deptDesc: dept.deptDesc
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doSelect(data) {
      const deptObj = {
        dept: data.dept,
        deptDesc: data.deptDesc
      }
      this.$emit('selectDept', deptObj)
      this.$emit('close')
    }
  },
  computed: {
    menu() {
      return this.$store.state.polTypeParam.menu
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
